var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:[{ active: _vm.isActive }, 'button-answer'],attrs:{"type":"button"},on:{"click":_vm.click}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }